import { Provider } from 'react-redux';
import TracingProvider from './tracing/tracingProvider';
import SessionVerification from '~/components/auth/SessionVerification';
import GlobalStyle from '~/components/branding/styles';
import ThreadThemeProvider from '~/components/theme/themeProvider';
import Routes from '~/routes';
import { store } from '~/store';
import { stack } from '~/utils/component';

const Wrappers = stack(
  ThreadThemeProvider,
  TracingProvider,
  SessionVerification,
);

const App = () => (
  <Provider store={store}>
    <Wrappers>
      <GlobalStyle />
      <Routes />
    </Wrappers>
  </Provider>
);

export default App;
